import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import SEOHelmet from '../components/SEOHelmet';

const TYPE_INFO = {
 income_protection: { icon: '️', label: 'Income Protection' },
 public_liability: { icon: '', label: 'Public Liability' },
 workers_comp: { icon: '⚖️', label: 'Workers Compensation' },
 professional_indemnity: { icon: '', label: 'Professional Indemnity' },
};

export default function InsurancePage() {
 const navigate = useNavigate();
 const [products, setProducts] = useState([]);
 const [loading, setLoading] = useState(true);
 const user = JSON.parse(localStorage.getItem('user') || '{}');
 const audience = user.role || 'worker';

 useEffect(() => {
 const load = async () => {
 try { const r = await axios.get(`/api/insurance?audience=${audience}`); setProducts(r.data || []); } catch { /* silent */ }
 setLoading(false);
 };
 load();
 }, []);

 return (
 <div className="min-h-screen bg-neutral-50">
 <SEOHelmet title="Insurance Marketplace" description="Protect yourself with insurance designed for shift workers and employers." />
 <div className="bg-white border-b border-neutral-200 sticky top-0 z-10">
 <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
 <button onClick={() => navigate(-1)} className="p-2 hover:bg-neutral-100 rounded-lg text-neutral-500">←</button>
 <h1 className="font-bold text-neutral-900">️ Insurance</h1>
 </div>
 </div>

 <div className="max-w-3xl mx-auto px-4 py-5">
 <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl p-5 text-white mb-5">
 <h2 className="text-xl font-bold mb-1">Protect Your {audience === 'employer' ? 'Business' : 'Income'}</h2>
 <p className="text-blue-100 text-sm">Insurance tailored for the gig economy. Compare options from trusted Australian providers.</p>
 </div>

 {loading ? (
 <div className="flex justify-center py-16"><div className="w-7 h-7 border-2 border-brand-500 border-t-transparent rounded-full animate-spin" /></div>
 ) : (
 <div className="space-y-3">
 {products.map(p => {
 const info = TYPE_INFO[p.type] || { icon: '', label: p.type };
 return (
 <div key={p.id} className="bg-white rounded-2xl p-5 border border-neutral-100 shadow-sm hover:shadow-md transition">
 <div className="flex items-start justify-between gap-3">
 <div className="flex-1">
 <div className="flex items-center gap-2 mb-1">
 <span className="text-lg">{info.icon}</span>
 <h3 className="font-bold text-neutral-900 text-sm">{p.name}</h3>
 </div>
 <p className="text-xs text-neutral-400 mb-1">{p.provider} · {info.label}</p>
 <p className="text-xs text-neutral-500 leading-relaxed">{p.description}</p>
 </div>
 <div className="text-right shrink-0">
 {parseFloat(p.price_from || 0) > 0 ? (
 <>
 <p className="text-lg font-black text-neutral-900">From ${parseFloat(parseFloat(p.price_from || 0)).toFixed(0)}</p>
 <p className="text-[10px] text-neutral-400">{p.price_period}</p>
 </>
 ) : (
 <p className="text-sm font-bold text-brand-600">Varies</p>
 )}
 <a href={p.referral_url} target="_blank" rel="noopener noreferrer"
 className="inline-block mt-2 px-4 py-1.5 bg-brand-500 text-white font-bold text-xs rounded-lg hover:bg-brand-600 transition">
 Get Quote →
 </a>
 </div>
 </div>
 </div>
 );
 })}
 </div>
 )}

 <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-xl">
 <p className="text-xs text-amber-700"><strong>Disclaimer:</strong> ShiftMatch provides insurance information for reference only. We are not a licensed insurance broker. Always read the PDS and consider your circumstances before purchasing.</p>
 </div>
 </div>
 </div>
 );
}
